import { useState } from 'react'
import { AlphabeticalMenuItems } from '../../Desktop/MenuComponents/AlphabeticalMenu/AlphabeticalMenuItems'
import type { NextLevelProps } from '../../global-navigation'

export const AlphabeticalMenu = ({ menu }: NextLevelProps) => {
  const [query, setQuery] = useState('')

  return (
    <div className="px-6 py-4 mb-3">
      <div className="px-3 py-1.5 space-y-1">
        <p
          style={{ color: menu?.titleColor ? menu.titleColor : '#0A0A0A' }}
          className="font-bold tracking-[0.08px] text-base"
        >
          {menu.title}
        </p>
      </div>
      <div className="mt-3 mb-1 rounded-lg border border-solid border-[#BFC1C3] flex flex-row w-full overflow-hidden">
        <div className="w-[calc(100%-54px)]">
          <input
            type="text"
            className="w-full h-full px-4 py-[15px] text-[#232323] text-sm tracking-[-0.42px] font-normal placeholder:italic placeholder:font-[325] placeholder:text-[#666] focus:outline-none"
            name="search-brand"
            placeholder="Digita il nome del Brand"
            pattern="[^A-Za-z0-9]+"
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>
      <div className="px-3 pt-3 space-y-3">
        {menu && <AlphabeticalMenuItems menu={menu} query={query} />}
      </div>
    </div>
  )
}
